
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/returns-online",
      function () {
        return require("private-next-pages/returns-online/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/returns-online"])
      });
    }
  